"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4063],{

/***/ 74063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ category_CategoryItems; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-img-webp/dist/react-img-webp.esm.js
var react_img_webp_esm = __webpack_require__(23085);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./src/components/category/AlphabeticData/index.jsx









// TODO: Add react-sizes to Auto-Collapse Mobile and expand otherwise
var AlphabeticData = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AlphabeticData, _Component);
    var _super = (0,_create_super/* default */.Z)(AlphabeticData);
    function AlphabeticData(props) {
        (0,_class_call_check/* default */.Z)(this, AlphabeticData);
        var _this;
        _this = _super.call(this, props);
        _this.toggle = _this.toggle.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            collapse: true
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(AlphabeticData, [
        {
            key: "toggle",
            value: function toggle() {
                if (this.props.collapsable) {
                    this.setState({
                        collapse: !this.state.collapse
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, data = _props.data, keyName = _props.keyName;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "category-elements-group letter-specific",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "category-elements-wrapper",
                        id: keyName,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "key-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "group-title",
                                    children: keyName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "elements-container",
                                children: data.map(function(item, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "category-element",
                                        onClick: function() {
                                            return router_default().push("/category/[categoryid]?categoryid=".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug), "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug)).then(function() {
                                                return window.scrollTo(0, 0);
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/category/[categoryid]",
                                            as: "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/category/".concat(item.urlSlug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    "data-hover": "size 06",
                                                    children: item.name
                                                })
                                            })
                                        })
                                    }, i);
                                })
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return AlphabeticData;
}(react.Component);
/* harmony default export */ var category_AlphabeticData = (AlphabeticData);

// EXTERNAL MODULE: ./src/components/category/Services/index.js
var Services = __webpack_require__(83407);
;// CONCATENATED MODULE: ./src/components/category/CategoryItems/index.jsx











var CategoryItems = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CategoryItems, Component);
    var _super = (0,_create_super/* default */.Z)(CategoryItems);
    function CategoryItems() {
        (0,_class_call_check/* default */.Z)(this, CategoryItems);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CategoryItems, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, groupByAlphaFilter = _props.groupByAlphaFilter, SearchName = _props.SearchName, categoryIndex = _props.categoryIndex, categories = _props.categories, SortBy = _props.SortBy, shop = _props.shop;
                var CategoryCount = categories.length ? categories.length : 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: Object.keys(groupByAlphaFilter).length > 2 && CategoryCount > 15 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "alphabetical-selection-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alphabetical-selection-title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                    children: [
                                        "Jump To Your ",
                                        SearchName ? SearchName : "Item",
                                        " Quickly."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "header mt-0",
                                children: Object.keys(groupByAlphaFilter).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "letter",
                                        href: "#" + key,
                                        children: key
                                    }, key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "items",
                                children: Object.keys(groupByAlphaFilter).length > 0 ? Object.keys(groupByAlphaFilter).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(category_AlphabeticData, {
                                        data: groupByAlphaFilter[key],
                                        keyName: key,
                                        categoryIndex: categoryIndex,
                                        collapsable: false
                                    }, key);
                                }) : "Loading"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "category-elements-group mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "category-elements-wrapper",
                            children: categories ? categories // TODO: add Sort by Sort Order Here...  ( Check for NUll use 'category/vehicle-batteries-car-or-truck-dodge-ram-1500' as a Sample)
                            .sort(function(a, b) {
                                if (SortBy === "Asc") return Services/* collator.compare */.V.compare(a.name, b.name);
                                else return Services/* collator.compare */.V.compare(b.name, a.name);
                            }).sort(function(a, b) {
                                return b.sortOrder ? b.sortOrder : 999999 < a.sortOrder ? a.sortOrder : 999999;
                            }).map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-element ".concat(item.imageOnly ? "image-only" : ""),
                                    onClick: function() {
                                        router_default().push("/category/[categoryid]?categoryid=".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug), "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug)).then(function() {
                                            return window.scrollTo(0, 0);
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/category/[categoryid]",
                                        as: "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug),
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug),
                                            children: [
                                                item.imageUrl && _this.props.showImages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_img_webp_esm/* Image */.Ee, {
                                                    objectFit: "contain",
                                                    width: "100px",
                                                    height: "100px",
                                                    alt: item.name,
                                                    src: item.imageUrl,
                                                    webP: item.imageUrl.substr(0, item.imageUrl.lastIndexOf(".") < 0 ? item.imageUrl.length : item.imageUrl.lastIndexOf(".")) + ".webp",
                                                    className: "lazyload"
                                                }) : "",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    "data-hover": "size 06",
                                                    children: item.name
                                                })
                                            ]
                                        })
                                    })
                                }, i);
                            }) : "Loading..."
                        })
                    })
                });
            }
        }
    ]);
    return CategoryItems;
}(react.Component);
/* harmony default export */ var category_CategoryItems = (CategoryItems);


/***/ }),

/***/ 23085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image$1; }
/* harmony export */ });
/* unused harmony exports Context, canUseWebP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var WebP = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  supportWebP: false
});

var Image = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (props) {
  var childProps = _objectSpread({}, props);

  delete childProps.webP;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WebP.Consumer, null, function (value) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("img", _extends({}, childProps, {
      src: value.supportWebP && props.webP || props.src
    }));
  });
});

var checked; // eslint-disable-line

function canUseWebP() {
  if ("undefined" !== typeof checked) {
    return checked;
  }

  if ("object" !== (typeof document === "undefined" ? "undefined" : _typeof(document))) {
    return false;
  }

  var canvas = document.createElement("canvas");

  if (!canvas.getContext || !canvas.getContext("2d")) {
    return checked = false;
  }

  return checked = canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
}

var WebPController = function WebPController(_ref) {
  var accept = _ref.accept,
      children = _ref.children;

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("string" === typeof accept && accept.indexOf("image/webp") !== -1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      supportWebP = _React$useState2[0],
      setSupport = _React$useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!supportWebP && canUseWebP()) {
      setSupport(true);
    }
  }, []);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WebP.Provider, {
    value: {
      supportWebP: supportWebP
    }
  }, children);
};



var ContextPackage = /*#__PURE__*/Object.freeze({
  Image: Image,
  WebP: WebP,
  WebPController: WebPController
});

var Image$1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (props) {
  var childProps = _objectSpread({}, props);

  delete childProps.webP;
  delete childProps.useWebP;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("img", _extends({}, childProps, {
    src: props.useWebP && props.webP || props.src
  }));
});
var ImageDefaultProps = {
  useWebP: canUseWebP()
};
Image$1.defaultProps = ImageDefaultProps;

var Context = (/* unused pure expression or super */ null && (ContextPackage));




/***/ })

}]);